import HomeView from '../views/HomeView.vue';
import { createRouter, createWebHashHistory } from 'vue-router';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component () {
      return import(/* webpackChunkName: "about" */ '../views/AboutView.vue');
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
